import type { ThemeDefinition } from "./types";
import { hexToSrgb, hexToLinear } from "./palette";

export const depths: ThemeDefinition = {
  label: "Depths",
  className: "theme-depths",
  bg: "#0a1c1c",
  text: "#80d8d8",
  textMuted: "rgba(128,216,216,0.55)",
  accent: "#d4725c",
  glassRgb: "10,28,28",
  border: "rgba(255,255,255,0.08)",
  borderHighlight: "rgba(255,255,255,0.18)",
  separator: "rgba(128,216,216,0.18)",
  selection: "#d4725c",
  selectionText: "#0a1c1c",
  gridColor: "#80d8d8",
  noiseOpacity: "0.05",
  gridOpacity: "0.7",
  textShadow: "0 -1px 0px rgba(255,255,255,0.1), 0 10px 0px rgba(0,0,0,0.55)",
  gpuClear: hexToSrgb("#0a1c1c"),
  gpuGridLine: hexToLinear("#80d8d8"),
  gpuGridAlpha: 0.7,
  gpuAxisX: hexToLinear("#d4725c"),
  gpuAxisZ: hexToLinear("#80d8d8"),
  axisXColor: "#d4725c",
  axisZColor: "#80d8d8",
  font: '"Space Grotesk", sans-serif',
};
